import { makeStyles } from "tss-react/mui";

const useUserInfoStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    backgroundColor: theme.palette.surface.light,
    borderRadius: "8px",
  },
  name: {
    color: theme.palette.text.primary,
    fontSize: "1rem",
  },
  icon: {
    color: theme.palette.text.secondary,
  },
}));

export default useUserInfoStyles;